module.exports = __webpack_public_path__ + "img/file-pdf-solid.2b6ca22c.svg";